/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import {useParams} from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_GET_REQUEST, API_SERVER, API_COMMENT } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { YEAR, MONTH, TODAY, convertDateDBtoIndo } from "../../functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../style/general/node.entry.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/


const Screen = ({loading, error}) => {

    let STORAGE_USER = reactLocalStorage.get('@guest_user');
    
    const { slug } = useParams();

    const [data, set_data] = useState(null);

    const [comment, set_comment] = useState(null);

    const [message, set_message] = useState('');
    
    const [message_update, set_message_update] = useState('');

    const [refresh, set_refresh] = useState(false)

    const [handle_update, set_handle_update] = useState(undefined)

    //#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    const _read = () => {

        loading(true);

		API_GET_PUBLIC('client/post__________?slug=' + slug)
        .then((response) => {
			if(response.data.result === 'success'){
                console.log('data post : ', response.data)
                loading(false)
                set_data(response.data.data.post[0])
                set_comment(response.data.data.comment)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _comment = () => {

        if(loading === true){
            return
        }

        if(message){

            set_refresh(false)

            let date_combine = YEAR + '-' + MONTH + '-' + TODAY;
            
            loading(true);
    
            API_COMMENT('client/comment__________'
                + '?slug=' + slug
                + '&level=' + redux_user.data[0].level
                + '&bamboo=' + redux_user.data[0].bamboo
                + '&comment=' + message
                + '&date=' + date_combine
                + '&name=' + redux_user.data[0].name
                + '&username=' + redux_user.data[0].username
                + '&action=insert'
            )
            .then((response) => {
                if(response.data.result === 'success'){
                    set_message('');
                    error('');
                    loading(false)
                    set_refresh(true)
                }else if(response.data.error){
                    error(response.data.error)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }
        
    }

    const _delete = (bamboo_params) => {
        
        if(bamboo_params){

            set_refresh(false)
        
            loading(true);
        
            API_COMMENT('client/comment__________'
                + '?bamboo=' + bamboo_params
                + '&action=delete'
            )
            .then((response) => {
                if(response.data.result === 'success'){
                    set_message('');
                    error('');
                    loading(false)
                    set_refresh(true)
                }else if(response.data.error){
                    error(response.data.error)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }
        
    }

    const _update = (bamboo_params) => {
        
        if(bamboo_params){

            set_refresh(false)
        
            loading(true);
        
            API_COMMENT('client/comment__________'
                + '?bamboo=' + bamboo_params
                + '&comment=' + message_update
                + '&action=update'
            )
            .then((response) => {
                if(response.data.result === 'success'){
                    set_message('');
                    set_handle_update(undefined);
                    error('');
                    loading(false)
                    set_refresh(true)
                }else if(response.data.error){
                    error(response.data.error)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }
        
    }
    
    useEffect(() => {
        
        _read()
        
        if(STORAGE_USER === undefined){
            _set_redux_user('')
        }else{
            _set_redux_user(JSON.parse(STORAGE_USER))
        }

    }, [slug, refresh])

    const createMarkup = () => {
        return {__html: JSON.parse(decode(data.entry))}
    }

    return (
        <>
            {data &&
            
                <Helmet>

                    <meta name="description" content={decode(data.description)}/>
                    <title>{decode(data.title)}</title>

                    {/* Essential META Tags */}
                    <meta property="og:type" content="post"/>
                    <meta property="og:title" content={decode(data.title)}/>
                    <meta property="og:description" content={decode(data.description)}/>
                    <meta property="og:image" itemprop="image" content={decode(data.preview)}/>
                    <meta property="og:url" content={window.location.href}/>
                    <meta name="twitter:card" content="summary_large_image"/>
                    {/* Non-Essential, But Recommended */}
                    <meta property="og:site_name" content={decode(data.title)}/>
                    <meta name="twitter:image:alt" content={decode(data.preview)}/>

                </Helmet>
            }

            <div className="_container" style={{maxWidth: 800}}>
                {data&&
                    <div className="_lily_pad_h_d __section_pages_title">
                        <p className="_push_b_s">{decode(data.level.toUpperCase())}</p>
                        <h1>{decode(data.title)}</h1>
                    </div>
                }
            </div>

            {data ?
                <img src={data.preview} alt={decode(data.title)}/>
                :
                <div className="__pages_image"/>
            }
            
            {data&&
                <div className="_container" style={{maxWidth: 800}}>
                    <div className="_push_t_g">
                        <div className="_push_t_s _push_b_d _lily_pad_h_d">
                            <p className="_font_size_16px _cl_smooth_00">{decode(data.author)}</p>
                            <p className="_push_t_s">Published, {decode(data.date)}</p>
                        </div>
                        <div className="_lily_pad_h_d">
                            <div className="__entry" dangerouslySetInnerHTML={createMarkup()}></div>
                            <div className="__section_pages_title">
                                <h1>Komentar</h1>
                            </div>
                            {
                                comment&&comment.map((item, index) => (
                                    <div key={index} className="_row _push_b_d">
                                        <div className="__comment_circle">
                                            {decode(item.username.charAt(0))}
                                            {
                                                item.level === "super" &&
                                                <div className="__comment_circle_badge"/>
                                            }
                                        </div>
                                        <div className="_column _push_l_m _push_r_m">
                                            <small className="_font_size_10px _cl_smooth_2">{convertDateDBtoIndo(decode(item.date))}</small>
                                            <p>
                                                {decode(item.comment)}
                                            </p>
                                            {
                                                item.bamboo_comment === handle_update &&
                                                <>
                                                    <br/>
                                                    <textarea
                                                        className="__textarea _push_b_m"
                                                        placeholder={'Ubah Komentar'}  
                                                        onChange={e => set_message_update(e.target.value)}
                                                        value={message_update}>
                                                    </textarea>
                                                    <div>
                                                        <a className="_btn" onClick={() => _update(item.bamboo_comment)} style={{cursor: "pointer"}}>
                                                            Ubah
                                                        </a>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        {
                                            redux_user.data&&redux_user.data[0].bamboo === item.bamboo &&
                                            <>
                                                <div onClick={() => {
                                                    if(handle_update){
                                                        set_handle_update(undefined);
                                                        set_message_update('')
                                                    }else{
                                                        set_handle_update(item.bamboo_comment)
                                                    }
                                                }} className="__comment_circle _push_r_m" style={{cursor: 'pointer'}}>
                                                    <ion-icon name="pencil-outline"></ion-icon>
                                                </div>
                                                <div onClick={() => _delete(item.bamboo_comment)} className="__comment_circle" style={{cursor: 'pointer'}}>
                                                    <ion-icon name="trash-outline"></ion-icon>
                                                </div>
                                            </> 
                                        }
                                    </div>
                                ))
                            }
                            {
                                redux_user.data ?

                                    <div className="_container">
                                        <br></br>
                                        <p className="_push_b_d">
                                            Sebagai
                                            {
                                                ` `
                                            }
                                            <b>
                                                {
                                                    redux_user.data[0].name
                                                }
                                            </b> 
                                        </p>
                                        <div>
                                            <div>
                                                <div>
                                                    <textarea
                                                        className="__textarea"
                                                        placeholder={'Komentar'}  
                                                        onChange={e => set_message(e.target.value)}
                                                        value={message}>

                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <br/>
                                        <div>
                                            <a className="_btn" onClick={() => _comment()} style={{cursor: "pointer"}}>
                                                Komentar
                                            </a>
                                        </div>
                                    </div>

                                :

                                <div className="_container">
                                    <p>Login sebagai tamu untuk dapat berkomentar</p>
                                    <br/>
                                    <Link 
                                        className="_btn"
                                        to={{
                                            pathname: '/guest',
                                        }} 
                                    >
                                        Login
                                    </Link>
                                </div>
                                
                        
                            }
                        </div>
                        {/* <div className="_push_t_s _column_auto">
                            <div className="__pages_sosmed">
                                <a href={'https://facebook.com/flamecore'}>
                                    <ion-icon name="logo-facebook"></ion-icon>
                                </a>
                                <a href={'https://instagram.com/flamecore'}>
                                    <ion-icon name="logo-instagram"></ion-icon>
                                </a>
                                <a href={'https://twitter.com/flamecore'}>
                                    <ion-icon name="logo-twitter"></ion-icon>
                                </a>
                                <a href={'https://youtube.com/'}>
                                    <ion-icon name="logo-youtube"></ion-icon>
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>    
            }
        </>
    );

}

export default Screen;